import React from 'react'
import { observer } from 'mobx-react-lite'
import InfluencersList from './InfluencersList'

export default observer(function DraftReviewList() {
  return (
    <div className="w-[353px] h-full border-2 border-rb-widget-border dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode overflow-y-auto p-4 shrink-0">
      <h2 className="font-bold text-xl mb-4 dark:text-white">Draft Review</h2>
      <InfluencersList />
    </div>
  )
})